// @flow
import React, {type Node} from 'react'
import classNames from 'classnames'
import {
  type RelayFragmentContainer,
  createFragmentContainer,
  graphql,
} from 'react-relay'

import DefaultAvatar from 'components/ui/icons/DefaultAvatar'
import VisuallyHidden from 'components/ui/VisuallyHidden'

import styles from './index.scss'
import type {Person} from './types'

type Props = $ReadOnly<{
  person: Person,
  size: "small" | "medium" | "xLarge",
  grayOverlay?: boolean,
  redBorder?: boolean,
}>;

function PersonAvatar({
  person,
  size,
  redBorder = false,
  grayOverlay = false,
}: Props): Node {
  // eslint-disable-next-line no-underscore-dangle
  const agentAvatarSrc = window.__applicationStartArgs?.assetPaths?.aiAgentAvatar
  const isAgent = person.isAgent
  const classes = classNames(styles.container, {
    [styles.small]: size === 'small',
    [styles.medium]: size === 'medium',
    [styles.xLarge]: size === 'xLarge',
    [styles.redBorder]: redBorder,
    [styles.agentAvatar]: isAgent,
  })
  return (
    <div className={classes}>
      {grayOverlay && <div className={styles.overlay} />}
      <VisuallyHidden>{person.name}</VisuallyHidden>
      {isAgent && agentAvatarSrc && <img className={styles.image} src={agentAvatarSrc} alt="" />}
      {isAgent && !agentAvatarSrc && <DefaultAvatar className={styles.image} />}
      {!isAgent && person.avatarUrl && (
        <img className={styles.image} src={person.avatarUrl} alt="" />
      )}
      {!isAgent && !person.avatarUrl && (
        <DefaultAvatar className={styles.image} />
      )}
    </div>
  )
}

export default (createFragmentContainer(PersonAvatar, {
  person: graphql`
    fragment PersonAvatar_person on Person {
      avatarUrl
      name
      isAgent
    }
  `,
}): RelayFragmentContainer<typeof PersonAvatar>)
